import { Routes } from '@angular/router';
import {
  cmsInEditorGuard,
  CmsPageComponent,
  cmsPageTemplateResolver,
} from '@domgen/dgx-fe-cms';
import { privacyPolicyGuard } from '@support/feature-content';

export const SUPPORT_SHELL_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CmsPageComponent,
    canActivate: [cmsInEditorGuard],
    data: {
      redirectTo: '/support/contact-us',
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
    },
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('@support/feature-contact-us').then(
        (module) => module.CONTACT_US_ROUTES
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    canActivate: [privacyPolicyGuard],
    loadChildren: () =>
      import('@support/feature-content').then(
        (module) => module.CONTENT_ROUTES
      ),
  },
];
